/* flavors Drawer */
document.addEventListener('click', function (e) {
const trigger = e.target.closest('.flavors__drawer-open');
if (!trigger) return;

const popupClass = trigger.getAttribute('popup_id');
if (!popupClass) return;

// close any open popup first
document.querySelectorAll('.flavors__drawer.open')
    .forEach(el => el.classList.remove('open'));

const target = document.querySelector(`.flavors__drawer.${popupClass}`);
if (!target) return;

target.classList.add('open');
document.body.classList.add('flavors__drawer-is-open');
});

document.addEventListener('click', function (e) {
const closeTrigger = e.target.closest('.flavors__drawer-overlay, .flavors__drawer-close');
if (!closeTrigger) return;

document.body.classList.remove('flavors__drawer-is-open');

document.querySelectorAll('.flavors__drawer.open')
    .forEach(el => el.classList.remove('open'));
});
/* flavors Drawer */